import React from 'react';
import Typography from '@mui/material/Typography';
import renderHTML from 'html-react-parser';
import { Helmet } from 'react-helmet';

export default class CustomTabPage extends React.Component {
  render() {
    const { promotion, content, label } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{promotion.name} | {label}</title>
        </Helmet>

        <Typography variant="h4" align="center">
          {label}
        </Typography>

        <Typography variant="subtitle1" className="custom-tab-content">
          {content && renderHTML(content)}
        </Typography>
      </React.Fragment>
    )
  }
}
